<template>
    <span>
        <img v-if="width > 24" class="boost-icon" :id="boost"  src="/static/img/avatars/blank.png">
        <div v-else-if="value" class="boost-icon-container" :style="`background-image: URL('/static/img/icons/${boost}.png');`"><center><span class="value-text">{{animatedNumber}} {{unit}}</span></center></div>
        <img v-else :src="`/static/img/icons/${boost}.png`" :width="width">
    </span>
</template>

<script>
    //import TWEEN from '@tweenjs/tween.js'
    export default {
        name: 'elv-boost-icon',
        props: { 'boost': {required:true},
                 'width': {default: 24, required: false},
                 'value': {required:false}
        },
        data () {
            return {
                unit: 'k',
                animatedNumber: 0,
            }
        },
        computed: {
            formattedValue : {
                get: function() {
                    return this.formatNumber(this.value);
                }
            }
        },
        created() {
            this.animatedNumber = this.formatNumber(this.value);//parseInt((this.value/1000).toFixed(0));//this.formatNumber( this.value ); // Sets the initial value.
        },
        watch: {
            formattedValue: function(newValue, oldValue) {
                var vm = this;
                function animate () {
                    if (TWEEN.update()) {
                        requestAnimationFrame(animate)
                    }
                }

                new TWEEN.Tween({ tweeningNumber: oldValue })
                    .easing(TWEEN.Easing.Quadratic.Out)
                    .to({ tweeningNumber: newValue }, 800)
                    .onUpdate(function () {
                        vm.animatedNumber = this.tweeningNumber.toFixed(0)
                    })
                    .start()

                animate()
            }
        },
        methods: {
            formatNumber: function(number) {
                try {
                    //console.log("number in: " + number);
                    if (!number) {
                        return 0;
                    }
                    else if (number < 10000) {
                        this.unit = '';
                        //console.log("it's < 10000", parseInt(number.toFixed(0)));
                        return parseInt(number.toFixed(0));

                    } else if(number > 10000) {
                        this.unit = 'k'
                        return parseInt((number / 1000).toFixed(0));
                    } else {
                        return -1;
                    }
                }catch(err) {
                    console.log("Error in BoostIcon formatNumber: ",err);
                }
            }
        }
    }



</script>


<style>

    .value-text {
        position:relative;
        top:24px;
        background-color: rgba(255, 255, 255, 0.75);
        font-size: 80%;
        padding: 0px 2px 0px 2px;
        text-align: center;
        width: 28px;
    }
    .boost-icon-container {
        background-repeat: no-repeat;
        background-position-y: top;
        background-position-x: center;
        position:relative;
        top:-5px;
        margin-top: auto;
        margin-bottom: auto;
        width:32px;
        height:24px;
    }

    .boost-icon {
        width: 32px;
        height: 32px;
    }
    .relic-icon {
        width:32px;
        height: 32px;
    }

    #crystal.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -64px 0px;
    }
    #elixir.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -96px 0px;
    }
    #gems.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -128px 0px;
    }
    #magic_dust.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -160px 0px;
    }
    #marble.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -192px 0px;
    }
    #planks.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -224px 0px;
    }
    #scrolls.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -256px 0px;
    }
    #silk.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -288px 0px;
    }
    #steel.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat 0px -32px;
    }
    #sentinetsteel.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -32px -32px;
    }
    #sentinetplanks.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -64px -32px;
    }
    #sentientmarble.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -96px -32px;
    }
    #sentientsilk.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -128px -32px;
    }
    #sentientscrolls.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -160px -32px;
    }
    #sentientcrystal.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -192px -32px;
    }
    #sentientelixir.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -224px -32px;
    }
    #sentientgems.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -256px -32px;
    }
    #sentientmagic_dust.boost-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -288px -32px;
    }


    #crystal.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -96px -192px;
    }
    #elixir.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -128px -192px;
    }
    #gems.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -160px -192px;
    }
    #magic_dust.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -192px -192px;
    }
    #marble.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -224px -192px;
    }
    #planks.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -256px -192px;
    }
    #scrolls.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -288px -192px;
    }
    #silk.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -32px -224px;
    }
    #steel.relic-icon {
        background: url('/static/img/icons/resources-big.png') no-repeat -32px -256px;
    }

</style>


// WEBPACK FOOTER //
// src/components/ElvBoostIcon.vue